import {
    CREATE_DYEING_DC_DETAILS_FAILURE,
    CREATE_DYEING_DC_DETAILS_REQUEST,
    CREATE_DYEING_DC_DETAILS_SUCCESS,
    CREATE_USER_FORM_DYEING_DC_DETAILS,
    DELETE_DYEING_DC_DETAILS_FAILURE,
    DELETE_DYEING_DC_DETAILS_REQUEST,
    DELETE_DYEING_DC_DETAILS_SUCCESS,
    FETCH_SINGLE_DYEING_DC_DETAILS_FAILURE,
    FETCH_SINGLE_DYEING_DC_DETAILS_REQUEST,
    FETCH_SINGLE_DYEING_DC_DETAILS_SUCCESS,
    FETCH_DYEING_DC_DETAILS_FAILURE,
    FETCH_DYEING_DC_DETAILS_REQUEST,
    FETCH_DYEING_DC_DETAILS_SUCCESS,
    DYEING_DC_DETAILS_USERFORM_RESET,
    UPDATE_DYEING_DC_DETAILS_FAILURE,
    UPDATE_DYEING_DC_DETAILS_REQUEST,
    UPDATE_DYEING_DC_DETAILS_SUCCESS,
    FETCH_DYEING_DC_DETAILS_BY_ID_REQUEST,
    FETCH_DYEING_DC_DETAILS_BY_ID_SUCCESS,
    FETCH_DYEING_DC_DETAILS_BY_ID_FAILURE,
    FETCH_DYEING_DC_PREVIOUS_LIST_REQUEST,
    FETCH_DYEING_DC_PREVIOUS_LIST_SUCCESS,
    FETCH_DYEING_DC_PREVIOUS_LIST_FAILURE,
    FETCH_DYEING_DC_DETAILS_DC_NO_REQUEST,
    FETCH_DYEING_DC_DETAILS_DC_NO_SUCCESS,
    FETCH_DYEING_DC_DETAILS_DC_NO_FAILURE,
    FETCH_GRN_NO_BY_DYEING_DC_NO_REQUEST,
    FETCH_GRN_NO_BY_DYEING_DC_NO_SUCCESS,
    FETCH_GRN_NO_BY_DYEING_DC_NO_FAILURE,
    FETCH_DYEING_DC_DETAILS_COLOR_FROM_STYLE_REQUEST,
    FETCH_DYEING_DC_DETAILS_COLOR_FROM_STYLE_SUCCESS,
    FETCH_DYEING_DC_DETAILS_COLOR_FROM_STYLE_FAILURE,
    FETCH_DYEING_DC_DETAILS_RATE_FROM_STYLE_REQUEST,
    FETCH_DYEING_DC_DETAILS_RATE_FROM_STYLE_SUCCESS,
    FETCH_DYEING_DC_DETAILS_RATE_FROM_STYLE_FAILURE,
    FETCH_DYEING_DC_DETAILS_REPROCESS_PREV_LIST_REQUEST,
    FETCH_DYEING_DC_DETAILS_REPROCESS_PREV_LIST_FAILURE,
    FETCH_DYEING_DC_DETAILS_REPROCESS_PREV_LIST_SUCCESS,
    SHOW_PREVIOUS_LIST
} from './dyeingDCDetails.actionsType';

export const DYEING_DC_DETAILS = 'dyeingDcDetails';

let initialState = {
    loading: false,
    dyeingDCDetailsById: [],
    dyeingDCDetails: [],
    dyeingDCDetailsDcNo: [],
    dyeingDCDetailsColorFromStyle: [],
    previousList: [],
    grnNoByDyeingDcNo: [],
    dyeingReprocessprevlist: [],
    userform: {
        fldRate: 0,
        fldQuantity: 0,
        fldFKGSM: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        inwardId: []
    },
    selectedDyeingDCDetails: {},
    errorMessage: '',
    iperrorMessage: '',
    rateKg: '',
    showPrevious: true

};

export let dyeingDCDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_DYEING_DC_DETAILS_REQUEST:
        case FETCH_DYEING_DC_DETAILS_COLOR_FROM_STYLE_REQUEST:
        case FETCH_DYEING_DC_DETAILS_RATE_FROM_STYLE_REQUEST:
        case FETCH_GRN_NO_BY_DYEING_DC_NO_REQUEST:
        case FETCH_DYEING_DC_DETAILS_DC_NO_REQUEST:
        case FETCH_DYEING_DC_PREVIOUS_LIST_REQUEST:
        case FETCH_DYEING_DC_DETAILS_BY_ID_REQUEST:
        case CREATE_DYEING_DC_DETAILS_REQUEST:
        case FETCH_SINGLE_DYEING_DC_DETAILS_REQUEST:
        case UPDATE_DYEING_DC_DETAILS_REQUEST:
        case DELETE_DYEING_DC_DETAILS_REQUEST:
        case FETCH_DYEING_DC_DETAILS_REPROCESS_PREV_LIST_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_DYEING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                dyeingDCDetails: updatePayload
            };
        case FETCH_DYEING_DC_DETAILS_COLOR_FROM_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                dyeingDCDetailsColorFromStyle: updatePayload
            };
        case FETCH_DYEING_DC_DETAILS_RATE_FROM_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: { ...state.userform },
                rateKg: updatePayload
            };
        case FETCH_GRN_NO_BY_DYEING_DC_NO_SUCCESS:
            return {
                ...state,
                loading: false,
                grnNoByDyeingDcNo: updatePayload?.Inward
            };
        case FETCH_DYEING_DC_DETAILS_DC_NO_SUCCESS:
            return {
                ...state,
                loading: false,
                dyeingDCDetailsDcNo: updatePayload?.DYD
            };
        case FETCH_DYEING_DC_PREVIOUS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                previousList: updatePayload?.Program
            };
        case FETCH_DYEING_DC_DETAILS_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                dyeingDCDetailsById: updatePayload || []
            };

        case SHOW_PREVIOUS_LIST:
            return {
                ...state,
                loading: false,
                showPrevious: payload
            }

        case CREATE_DYEING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKAgentName: state?.userform?.fldFKAgentName,
                    fldFKMillName: state?.userform?.fldFKMillName,
                    fldRate: 0,
                    fldQuantity: 0,
                    fldFKGSM: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    inwardId: []
                }
            };
        case FETCH_SINGLE_DYEING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedDyeingDCDetails: updatePayload,
                userform: updatePayload
            };
        case UPDATE_DYEING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedDyeingDCDetails: {},
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldFKGSM: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    inwardId: []
                }
            };
        case DELETE_DYEING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldFKGSM: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    inwardId: []
                },
                selectedDyeingDCDetails: {}
            };
        case FETCH_DYEING_DC_DETAILS_REPROCESS_PREV_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                dyeingReprocessprevlist: updatePayload?.BED
            }
        case FETCH_DYEING_DC_DETAILS_FAILURE:
        case FETCH_DYEING_DC_DETAILS_COLOR_FROM_STYLE_FAILURE:
        case FETCH_DYEING_DC_DETAILS_RATE_FROM_STYLE_FAILURE:
        case FETCH_GRN_NO_BY_DYEING_DC_NO_FAILURE:
        case FETCH_DYEING_DC_DETAILS_DC_NO_FAILURE:
        case FETCH_DYEING_DC_PREVIOUS_LIST_FAILURE:
        case FETCH_DYEING_DC_DETAILS_BY_ID_FAILURE:
        case FETCH_SINGLE_DYEING_DC_DETAILS_FAILURE:
        case CREATE_DYEING_DC_DETAILS_FAILURE:
        case UPDATE_DYEING_DC_DETAILS_FAILURE:
        case DELETE_DYEING_DC_DETAILS_FAILURE:
        case FETCH_DYEING_DC_DETAILS_REPROCESS_PREV_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_DYEING_DC_DETAILS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case DYEING_DC_DETAILS_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldFKAgentName: state?.userform?.fldFKAgentName,
                    fldFKMillName: state?.userform?.fldFKMillName,
                    fldRate: 0,
                    fldQuantity: 0,
                    fldFKGSM: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    inwardId: [],
                    fldFKHSNCode: '',
                    FldInwardDia: '',
                    fldYarnCounts: '',
                    tblFabricname: '',
                    fldFabricGroup: ''
                },
                selectedDyeingDCDetails: {},
                rateKg: ''
            };
        default:
            return state;
    }
};
